import { render, staticRenderFns } from "./EventList.vue?vue&type=template&id=9b0d5ffc&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"
import style0 from "./EventList.vue?vue&type=style&index=0&id=9b0d5ffc&prod&scoped=true&lang=css"
import style1 from "./EventList.vue?vue&type=style&index=1&id=9b0d5ffc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b0d5ffc",
  null
  
)

export default component.exports